import {Fragment} from 'react';
import computeClassName from '../../../../../utils/computeClassName';
import computeTagName from '../../../../../utils/computeTagName';

const constants = Object.freeze({
  TAG_DEFAULT: 'span',
  CLASSNAME_BASE: 'flex-row truncate text-cc-body-small xs:text-cc-body-medium text-cc-secondary-contrast',
  CLASSNAME_IS_INLINE: {
    true: 'inline-flex',
    false: 'flex'
  }
});

const propsDefaults = Object.freeze({
  partnerRoleList: [],
  partnerLevel: '',
  isInline: true,
  tag: constants.TAG_DEFAULT
});

function getComputedClassName(propsClassName, isInline) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_IS_INLINE[isInline]}`);
}

export default function PartnerRolesAndLevelsRolesOnly({
  partnerRoleList = propsDefaults.partnerRoleList,
  isInline = propsDefaults.isInline,
  tag =  propsDefaults.tag,
  className
}) {
  const isDivided = partnerRoleList.length > 1;
  const ComputedTagName = computeTagName(tag, constants.TAG_DEFAULT);
  const computedClassName = getComputedClassName(className, isInline, isDivided);

  return (
    <ComputedTagName className={computedClassName}>
      {
        isDivided ?
          partnerRoleList.map((partnerRole, index) => {
            switch (index) {
              case 0: {
                return <span key={index} className="truncate pr-1.5" title={partnerRole}>{partnerRole}</span>
              }
              case partnerRoleList.length - 1: {
                return <Fragment key={index}><span className="text-cc-muted-contrast select-none">|</span><span className="truncate pl-1.5" title={partnerRole}>{partnerRole}</span></Fragment>
              }
              default: {
                return <Fragment key={index}><span className="text-cc-muted-contrast select-none">|</span><span className="truncate px-1.5" title={partnerRole}>{partnerRole}</span></Fragment>
              }
            }
          }) :
          <>
            <span>{partnerRoleList[0]}</span>
          </>
      }
    </ComputedTagName>
  );

}
